/**
 * OfferteClipboardContext - Slaat gekopieerde offerte-items op voor plakken elders.
 * Ondersteunt: kast, apparaat, werkblad, diverse, verlichting, plint.
 */
import { createContext, useContext, useState, useCallback } from 'react'

const OfferteClipboardContext = createContext(null)

export function OfferteClipboardProvider({ children }) {
  const [clipboard, setClipboard] = useState(null)

  const copyToClipboard = useCallback((item, itemType) => {
    setClipboard({ item, itemType, copiedAt: Date.now() })
  }, [])

  const clearClipboard = useCallback(() => {
    setClipboard(null)
  }, [])

  const value = {
    clipboard,
    copyToClipboard,
    clearClipboard,
    hasClipboard: !!clipboard,
  }

  return (
    <OfferteClipboardContext.Provider value={value}>
      {children}
    </OfferteClipboardContext.Provider>
  )
}

export function useOfferteClipboard() {
  const ctx = useContext(OfferteClipboardContext)
  if (!ctx) {
    return {
      clipboard: null,
      copyToClipboard: () => {},
      clearClipboard: () => {},
      hasClipboard: false,
    }
  }
  return ctx
}
